import { CreateShippingRateTableInputSchema } from "@redotech/redo-model/integration/redo-in-shipping/shipping-rate-table";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const modifyShippingMethods = {
  name: "modifyShippingMethods" as const,
  input: z.object({
    checkoutExperienceId: zExt.objectId(),
    shippingRateTablesToUpsert: z.array(
      z.object({
        id: z.union([
          z.object({ kind: z.literal("temporary"), value: z.string() }),
          z.object({ kind: z.literal("existing"), value: zExt.objectId() }),
        ]),
        createShippingRateTableInput: CreateShippingRateTableInputSchema,
      }),
    ),
    shippingRateTableIdsToDelete: z.array(zExt.objectId()),
  }),
  output: z.null(),
};
export type ModifyShippingMethodsInput = z.infer<
  typeof modifyShippingMethods.input
>;
